import React, { useState, useRef } from 'react';
import { ContentPopup } from 'components/ContentPopup.jsx';
import HoverTooltip from 'components/common/HoverTooltip';
import { DATA_SOURCE_ICONS } from 'components/quote_builder/DataSourceIcons.jsx';

/**
 * A clickable "Learn more" affordance shown next to the "Link to data source" link. Modelled on
 * show_drawing/ToolTip: a help icon wrapped in a HoverTooltip (a quick hover teaser) that, when
 * clicked, opens a ContentPopup that explains — and sells — what linking a price to a spreadsheet
 * does. A passive hover tooltip alone only pays off if the user happens to hover long enough; the
 * click is the deliberate action that surfaces the full pitch.
 */
const DataSourceLearnMore = () => {
  const [showInfo, setShowInfo] = useState(false);
  const popupRef = useRef();

  const openInfo = (event) => {
    event.preventDefault();
    if (typeof trackEvent === 'function') {
      trackEvent('data_source_learn_more_opened', {});
    }
    setShowInfo(true);
  };

  // The same three provider logos the real "Configure data source" popup shows, here as a static
  // "works with" trust signal (not clickable — this popup sells the feature and hands off to
  // "Link to data source"). Google Sheets and Airtable artwork include their wordmark; Excel is an
  // icon, so it gets a text label — mirroring DataSourceConnectButtons.
  const infoContent = (
    <div className="data-source-learn-more" style={{ textAlign: 'left' }}>
      <h3>{t('quote_builder.data_source_learn_more_title')}</h3>
      <div dangerouslySetInnerHTML={{ __html: t('quote_builder.data_source_learn_more_body_html') }} />
      <div className="data-source-learn-more-providers">
        <img src={DATA_SOURCE_ICONS.google_sheets} alt="Google Sheets" />
        <span className="data-source-learn-more-provider--excel">
          <img src={DATA_SOURCE_ICONS.microsoft_excel} alt="Microsoft Excel" /> {t('quote_builder.microsoft_excel')}
        </span>
        <img src={DATA_SOURCE_ICONS.airtable} alt="Airtable" />
      </div>
    </div>
  );

  return (
    <span className="data-source-learn-more-trigger" style={{ marginLeft: '10px' }}>
      <HoverTooltip title={t('quote_builder.link_to_data_source_hint')}>
        <a href="#" onClick={openInfo}>
          <i className="zmdi zmdi-pin-help"></i> {t('quote_builder.learn_more')}
        </a>
      </HoverTooltip>
      {showInfo && (
        <ContentPopup
          myRef={popupRef}
          autoOpen={true}
          content={infoContent}
          cancelButton={false}
          beforeClose={() => setShowInfo(false)}
        />
      )}
    </span>
  );
};

export default DataSourceLearnMore;
